import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo-safetypoint.png';

// Ejemplos de imágenes para los botones
import ventasImg from '../assets/ventas.png';
import inventarioImg from '../assets/inventario.png';
import pedidosImg from '../assets/pedidos.png';
import carritoImg from '../assets/carrito.png';
import reportesImg from '../assets/reportes.png';
import cotizacionImg from '../assets/cotizaciones.png';
import usuariosImg from '../assets/usuarios.png';

import './Inicio.css';

function Bienvenida({ usuario }) {
  const navigate = useNavigate();

  return (
    <div className="inicio-container">
      <div className="bienvenida">
        <h1 style={{ color: '#fd7119' }}>¡Bienvenido, {usuario.nombre}!</h1>
        <p>Selecciona una opción para comenzar.</p>
      </div>

      <div className="logo-inicio">
        <img src={logo} alt="Safety Point" />
      </div>

      <div className="botones-grid">
        <div className="boton-cajita" onClick={() => navigate('/ventas')}>
          <img src={ventasImg} alt="Ventas" className="icono-img" />
          <span className="nombre">Ventas</span>
        </div>

        <div className="boton-cajita" onClick={() => navigate('/inventario')}>
          <img src={inventarioImg} alt="Inventario" className="icono-img" />
          <span className="nombre">Inventario</span>
        </div>

        <div className="boton-cajita" onClick={() => navigate('/pedidos')}>
          <img src={pedidosImg} alt="Pedidos" className="icono-img" />
          <span className="nombre">Pedidos</span>
        </div>

        <div className="boton-cajita" onClick={() => navigate('/carrito')}>
          <img src={carritoImg} alt="Carrito" className="icono-img" />
          <span className="nombre">Carrito</span>
        </div>

        <div className="boton-cajita" onClick={() => navigate('/cotizaciones')}>
          <img src={cotizacionImg} alt="Cotizaciones" className="icono-img" />
          <span className="nombre">cotizaciones</span>
        </div>

        <div className="boton-cajita" onClick={() => navigate('/reportes')}>
          <img src={reportesImg} alt="Reportes" className="icono-img" />
          <span className="nombre">Reportes</span>
        </div>

        <div className="boton-cajita" onClick={() => navigate('/usuarios')}>
          <img src={usuariosImg} alt="Usuarios" className="icono-img" />
          <span className="nombre">Usuarios</span>
        </div>
      </div>
    </div>
  );
}

export default Bienvenida;
